export const personalInfoDetailStyles = {
  display: "flex",
  gap: "2%",
  flexDirection: "column",
};

export const detailsSectionStyles = {
  display: "flex",
  alignItem: "center",
  flexDirection: "column",
  gap: "0.2em",
};

export const DetailHeadingStyles = {
  fontSize: "1rem",
  fontWeight: "500",
};

export const paraStyles = {
  fontSize: "0.85rem",
  marginBottom: "0.2rem",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};
